import MigrationSettingsUserInput from './schema/migrationSettingsData';
import { createStore } from 'satcheljs';
import { MigrationSettingsDataType } from '../store/schema/migrationSettingsData';

const migrationSettingsUserInput: MigrationSettingsUserInput = {
    currentMigrationType: MigrationSettingsDataType.outlookForWindows,
    isApplyingSettings: false,
};

const store = createStore<MigrationSettingsUserInput>(
    'migrationSettingsUserInput',
    migrationSettingsUserInput
)();

export default () => store;
